import { all, takeLatest, call, put } from 'redux-saga/effects';
import { delay } from 'redux-saga';

import { SAGA_GET_EVENTS } from './actions';
import { setEvents, resetEvents, setBoundsEvents } from './actions';

import LandmarksAPI from '../shared/api/landmarksid';

const padding = 0.005;

const getEventBounds = (events) => {
  let minLng = 99999;
  let maxLng = -99999;

  let minLat = 99999;
  let maxLat = -99999;

  for (let e of events) {
    minLng = Math.min(minLng, e.long);
    maxLng = Math.max(maxLng, e.long);

    minLat = Math.min(minLat, e.lat);
    maxLat = Math.max(maxLat, e.lat);
  }

  return {
    northeast: {
        lat: minLat -padding,
        lng: maxLng + padding,
    },
    southwest: {
        lat: maxLat + padding,
        lng: minLng - padding,
    }
  }
}

function* getEvents(action){
  yield put(resetEvents());
  const response = yield call(LandmarksAPI.getEvents, action.payload.startDate, action.payload.endDate);
  if (response.error === null){

    let events = [...response.json.body.lore, ...response.json.body.lee.map((e) => {
      return {
        long: e.checkIn.latLong[0],
        lat: e.checkIn.latLong[1],
      }
    })];

    const bounds = getEventBounds(events);

    yield put(setEvents(response.json.body.lore, response.json.body.lee));
    yield delay(100);
    yield put(setBoundsEvents(bounds));
  } else {
    console.log(response);
  }
}

export default function* eventSagas() {
  yield all([
    takeLatest(SAGA_GET_EVENTS, getEvents),
  ]);
}



// WEBPACK FOOTER //
// ./src/Events/sagas.js